<script>
  /**
   * @type {string} width of the card
   */
  export let span = "col-span-1"
  /**
   * @type {number} counter value
   */
  export let count
  /**
   * @type {string} title of the card
   */
  export let titleText
  /**
   * @type {string} background gradient
   */
  export let gradient
  /**
   * @type {string} background color of the circles
   */
  export let color
  export let icon = "fa-solid fa-file-lines fa-1x"

  let array = [
    {
      bottom: Math.random() * 100,
      right: Math.random() * 50,
      delay: Math.random() * 2 + 1,
    },
    {
      bottom: Math.random() * 80,
      right: Math.random() * 40,
      delay: Math.random() * 7 + 1,
    },
    {
      bottom: Math.random() * 60,
      right: Math.random() * 30,
      delay: Math.random() * 11 + 1,
    },
    {
      bottom: Math.random() * 40,
      right: Math.random() * 20,
      delay: Math.random() * 15 + 1,
    },
  ]
</script>

<div class="relative h-[70px] {span} overflow-hidden rounded-md lg:col-span-1" style="background-image: linear-gradient(to left, {gradient});">
  <div class="absolute z-20 flex h-full w-full items-center justify-between py-3 pl-3 pr-0">
    <div class="flex items-center gap-3 text-sm text-white mobile:text-base lg:text-sm xl:text-base">
      <span class="w-5">
        <i class="fa-solid {icon} fa-lg md:fa-xl" />
      </span>
      <h3 class="font-bold text-white">{@html titleText}</h3>
    </div>

    <h3 class="px-3 font-mono text-4xl font-extrabold text-white lg:text-3xl xl:text-4xl">{count}</h3>
  </div>
  <div class="absolute inset-0 z-10">
    {#each array as arr, i}
      <div
        on:animationiteration={() => {
          arr.bottom = Math.random() * (100 - i * 20)
          arr.right = Math.random() * (50 - i * 10)
        }}
        class="circle absolute aspect-square translate-x-1/2 translate-y-1/2 rounded-full opacity-75"
        style="--bottom: {arr.bottom}%; --right: {arr.right}%;animation-delay:{arr.delay}s; background:{color} "
      />
    {/each}
  </div>
</div>

<style>
  @keyframes card-animation {
    0% {
      height: 0px;
      opacity: 1;
    }
    100% {
      height: 80px;
      opacity: 0.1;
    }
  }

  .circle {
    bottom: var(--bottom);
    right: var(--right);
    animation: card-animation 3s infinite linear;
  }
</style>
